import { html, type Html, Page, View } from 'rune-ts';
import klass from './CreatorRankingPage.module.scss';
import { LayoutView } from '../../../components/cells/Layout/LayoutView';
import { footer_links } from '../../../components/cells/Footer/constant';
import { CreatorTypeS } from '../../../../features/Creator/outbound/share';
import { BaseLayoutOptions } from '../../../../features/Core/service';
import { type ProductCardViewData } from '../../../../features/ProductList/type';
import { FloatingButton_recent_product } from '../../../components/cells/FloatingBox/FloatingButtons/FloatingButton_recent_product';
import { FloatingBox } from '../../../components/cells/FloatingBox/FloatingBox';
import { CreatorRankingPageController } from './CreatorRankingPageController';
import { font } from '../../../../shared/typography';
import { GlobalTimerManager } from '@services/MarppleShop/shared/util/timer';
import { TabListView } from '@services/MarppleShop/shared/components/cells/TabList/TabListView.ts';
import { createGoodsUrlBuilder } from '@services/MarppleShop/features/ProductList/util';

export interface CreatorRankingPageProps {
  creator_rankings: CreatorTypeS.ICreatorRanking[];
  recent_product?: ProductCardViewData;
  current_tab_id: CreatorTypeS.RankingPageType;
  layout_options: BaseLayoutOptions;
  updated_at: Date;
  date?: string;
}

export class CreatorRankingBody extends View<CreatorRankingPageProps> {
  private controller = new CreatorRankingPageController(this.data);

  protected override template(): Html {
    return html`
      <div class="${klass.creator_ranking}">
        <!--   타이틀     -->
        ${this.isMobile
          ? new TabListView({
              tabs: [
                {
                  tab_title: ET('mps2::recently_sold::title'),
                  selected: false,
                  href: createGoodsUrlBuilder().setPage('LATEST_SOLD').build(),
                },
                {
                  tab_title: ET('mps2::section_title::section_tabs::creator_ranking'),
                  selected: true,
                  href: `/${ET.lang}/@/creator/ranking/realtime`,
                },
              ],
            })
          : html`<section class="${klass.title}">${this.controller.titleView}</section>`}

        <!--   탭   -->
        <section class="${klass.tabs}">${this.controller.sectionTitleView}</section>

        <div class="${klass.updated_at} ${font('14_medium', '12_medium')}">
          ${this.controller.makeUpdateTimeString()}
        </div>

        <!--   랭킹 탑 100    -->
        <section class="${klass.rank_list}">${this.controller.creatorRankingListView}</section>

        <!--   로딩 뷰    -->
        ${this.controller.Loading}
      </div>
    `;
  }

  get isMobile(): boolean {
    return this.data.layout_options.is_mobile;
  }

  private controllerHandlePopstate = () => {
    this.controller.handlePopstate(this.data, this);
  };

  protected override onRender() {
    this.controller.delegateCalendarChangeEvent(this.data, this);

    this.controller.delegateProductLikeEvent(this);

    const globalTimer = GlobalTimerManager.getInstance();
    globalTimer.start(1000);

    window.addEventListener('popstate', this.controllerHandlePopstate);
  }

  protected override onUnmount(): void {
    super.onUnmount();

    const globalTimer = GlobalTimerManager.getInstance();
    globalTimer.stop();

    window.removeEventListener('popstate', this.controllerHandlePopstate);
  }
}

export class CreatorRankingPage extends Page<CreatorRankingPageProps> {
  protected override template(): Html {
    const { layout_options } = this.data;

    return html`
      <main class="${klass.creator_ranking_container}">
        ${new LayoutView(
          {
            body: new CreatorRankingBody(this.data),
            footer_data: { ...footer_links, lang: ET.lang, is_mobile: layout_options.is_mobile },
          },
          {
            full_width: layout_options.is_mobile,
            ...layout_options,
            has_bottom_tab_bar: true,
            selected_bottom_tab_idx: 1,
            floating_box: {
              recent_product: FloatingButton_recent_product.makeProps(this.data.recent_product),
              async renderHook(view: FloatingBox) {
                await FloatingBox.refreshRecentProductFloatingButton(view);
              },
            },
          },
        )}
      </main>
    `;
  }
}
